import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'react-loading-skeleton/dist/skeleton.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { register } from './serviceWorkerRegistration';


// WebView-specific initialization
const isWebView = window.ReactNativeWebView !== undefined;

const root = ReactDOM.createRoot(document.getElementById('root'));

function initializeApp() {
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App isWebView={isWebView} />
      </AuthProvider>
    </React.StrictMode>
  );
}

// Delay initialization for WebView environment
if (isWebView) {
  document.addEventListener('DOMContentLoaded', initializeApp);
  document.addEventListener('WebViewReady', initializeApp);
} else {
  initializeApp();
}


reportWebVitals();

register({
  onSuccess: (registration) => {

  },
  onUpdate: (registration) => {
  
    if (window.confirm('New version available! Update now?')) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
  onError: (error) => {
    console.error('Service worker registration error:', error);
  }
});